
<span class="content__transport-stop-details ci-caption-regular">
  {{ stopDetails() }}
</span>